import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 px-6 py-8">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-3">
          {/* Top row - Company name only */}
          <div className="text-left">
            <div className="font-semibold text-gray-900">
              DigiTables.ai
            </div>
          </div>
          
          {/* Bottom row - Description and right side content */}
          <div className="flex flex-col md:flex-row justify-between items-start space-y-4 md:space-y-0">
            {/* Left side - Description */}
            <div className="max-w-md text-left">
              <p className="text-sm text-gray-600 leading-relaxed">
                Transform unstructured tables into clean, ready-to-use data at scale with our full-service digitization platform.
              </p>
            </div>
            
            {/* Right side - Links and contact */}
            <div className="flex flex-col items-start md:items-end space-y-3">
              <div className="flex flex-col md:flex-row items-start md:items-center space-y-3 md:space-y-0 md:space-x-8">
                <div className="flex items-center space-x-6">
                  <Link to="/privacy" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    Privacy
                  </Link>
                  <Link to="/terms" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                    Terms
                  </Link>
                </div>
                <a 
                  href="mailto:connect@digitables.ai" 
                  className="text-sm text-gray-600 hover:text-blue-600 transition-colors"
                >
                  connect@digitables.ai
                </a>
              </div>
              <div className="text-sm text-gray-500">
                © {new Date().getFullYear()} Anansi Data Analytics Pte. Ltd. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
